export default "__VITE_ASSET__JI5KP7NW__"